/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TItemDefaultField {
    RATE = 'rate',
    P_AND_H_MULTIPLIER = 'p_and_h_multiplier',
    HANDLING_MULTIPLIER = 'handling_multiplier',
    TAXES_MULTIPLIER = 'taxes_multiplier',
}
